import linegraph from '../../../../../components/linegraph.vue'
import * as echarts from "echarts"
import iTable from "../../../../../components/Table.vue";
import IPagination from "../../../../../components/pagination.vue";
import { domainName } from "../../../../../utility/index";
import moment from 'moment';

export default {
    props: ["bindDriver"],
    data() {
        return {
            isShow: true,
            changeValue: [],
            optionLine: {},
            lineLoading: false,
            isLine: true,
            optionPie: {},
            pieLoading: false,
            orgId: '',
            driverNum: '',
            formInline: {
                carId: '',
            },
            height: '500',
            list: [], 
            option: {
                stripe: true, 
                border: true,
                loading: false, 
                highlightCurrentRow: false, 
                mutiSelect: true, 
                serialNumber: true, 
            },
            columnsAll: [
                {
                    prop: "driverNum",
                    label: this.$t('GovernmentRegulation.driverNum'),
                    align: "center",
                },
                {
                    prop: "name",
                    label: this.$t('GovernmentRegulation.name'),
                    align: "center",
                },
                {
                    prop: "orgName",
                    label: this.$t('common.orgName'),
                    align: "center",

                },
                {
                    prop: "overloadCount",
                    label: this.$t('GovernmentRegulation.overloadCount'),
                    align: "center",

                },
                {
                    prop: "speedOverCount",
                    label: this.$t('GovernmentRegulation.speedOverCount'),
                    align: "center",

                },
                {
                    prop: "outPositionCount",
                    label: this.$t('GovernmentRegulation.outPositionCount'),
                    align: "center",

                },
                {
                    prop: "collisionCount",
                    label: this.$t('GovernmentRegulation.collisionCount'),
                    align: "center",
                },
                {
                    prop: "leaveFenceCount",
                    label: this.$t('GovernmentRegulation.leaveFenceCount'),
                    align: "center",
                }
            ],
            columnsOne: [
                {
                    prop: "carId",
                    label: this.$t('common.carId'),
                    align: "center",
                },
                {
                    prop: "terminalId",
                    label: this.$t('common.terminalId'),
                    align: "center",
                },
                {
                    prop: "driverNum",
                    label: this.$t('GovernmentRegulation.driverNum'),
                    align: "center",
                },
                {
                    prop: "name",
                    label: this.$t('GovernmentRegulation.name'),
                    align: "center",
                },
                {
                    prop: "orgName",
                    label: this.$t('common.orgName'),
                    align: "center",

                },
                {
                    prop: "endTime",
                    label: this.$t('GovernmentRegulation.endTime'),
                    align: "center",

                },
                {
                    prop: "eventMessage",
                    label: this.$t('GovernmentRegulation.eventMessage'),
                    align: "center",
                }
            ],
            columns: [],
            operates: {
                width: 100,
                fixed: "right",
                list: [],
            },
            currentPage: 1,
            pageSize: 10, 
            total: 1, 
        }
    },
    components: {
        linegraph,
        iTable,
        IPagination
    },
    created() {
        this.getDate()
    },
    methods: {
        getDate() {
            const endTime = moment().format("YYYY-MM-DD");
            const startTime = moment().startOf('month').format("YYYY-MM-DD");
            this.changeValue = [startTime, endTime];
        },
        changeTime() {
            this.getFaultPeriod()
            this.getFaultMonth()
            this.getMonthOrderList('all')
        },
        initQuery(type) {
            this.type = type
            this.pageSize = 10
            this.currentPage = 1
            if (type == 'one') {
                this.columns = this.columnsOne
                this.getOneMonthOrderList()
            } else {
                this.columns = this.columnsAll
                this.getMonthOrderList()
            }
        },
        getFaultPeriod() {
            this.lineLoading = true
            let dateArr = []; 
            let overLoad = []; 
            let speedOver = []; 
            let collision = []; 
            let leaveFence = [];
            let outPosition = [];
            let param = {
                orgId: Number(this.orgId),
                driverNum: this.driverNum,
                selectType: 1,
                startTime: this.changeValue[0],
                endTime: this.changeValue[1],
            }
            this.$store.dispatch("DriverAnalysis/GET_QUERYDRIVERCOUNTMISTAKEPERIOD", param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        if (res.data.data.length > 0) {
                            this.isLine = true
                            res.data.data.map((item, index) => {
                                dateArr.push(item.updateTimeStr)
                                overLoad.push(item.overloadCount)
                                speedOver.push(item.speedOverCount)
                                collision.push(item.collisionCount)
                                leaveFence.push(item.leaveFenceCount)
                                outPosition.push(item.outPositionCount)
                                this.FaultLine(dateArr,overLoad,speedOver,collision,leaveFence,outPosition)
                            })
                        } else {
                            this.isLine = false
                        }
                    }
                }
                this.lineLoading = false
            }).catch(err => {
                this.lineLoading = false
            })
        },
        FaultLine(dateArr, overLoad, speedOver, collision, leaveFence, outPosition) {
            let option = {
                tooltip: {
                    trigger: 'axis',
                },
                legend: {
                    left: 'center',
                    data: [this.$t('GovernmentRegulation.overloadCount'), this.$t('GovernmentRegulation.speedOverCount'), this.$t('GovernmentRegulation.outPositionCount'), this.$t('GovernmentRegulation.collisionCount'), this.$t('GovernmentRegulation.leaveFenceCount')],
                    top: '10',
                    textStyle: {
                        color: '#fff'
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#fff',
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#fff',
                        }
                    },
                    splitLine: { show: false },
                    data: dateArr
                },
                grid: {
                    left: '1%',
                    right: '2%',
                    bottom: '3%',
                    containLabel: true
                },
                yAxis: [{
                    type: 'value',
                    name: this.$t('GovernmentRegulation.value'),
                    nameTextStyle: {
                        color: "white",
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: ['rgba(173,177,195,.1)'],
                            type: 'dashed'
                        }
                    },
                    axisLabel: {
                        formatter: '{value}',
                        color: '#fff'
                    }
                }],
                series: [
                    {
                        name: this.$t('GovernmentRegulation.overloadCount'),
                        type: 'line',
                        smooth: true,
                        color: '#48e1f9',
                        data: overLoad
                    },
                    {
                        name: this.$t('GovernmentRegulation.speedOverCount'),
                        type: 'line',
                        smooth: true,
                        color: '#409eff',
                        data: speedOver,
                    },
                    {
                        name: this.$t('GovernmentRegulation.outPositionCount'),
                        type: 'line',
                        smooth: true,
                        color: '#8f70f7',
                        data: outPosition,
                    },
                    {
                        name: this.$t('GovernmentRegulation.collisionCount'),
                        type: 'line',
                        smooth: true,
                        color: '#d860a1',
                        data: collision,
                    },
                    {
                        name: this.$t('GovernmentRegulation.leaveFenceCount'),
                        type: 'line',
                        smooth: true,
                        color: '#fc5b62',
                        data: leaveFence,
                    }
                ]
            }
            this.optionLine = option
        },

        getFaultMonth() {
            this.pieLoading = true
            let param = {
                orgId: Number(this.orgId),
                driverNum: this.driverNum,
                selectType: 1,
                startTime: this.changeValue[0],
                endTime: this.changeValue[1],
            }
            this.$store.dispatch("DriverAnalysis/GET_QUERYDRIVERCOUNTPERIODRATE", param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.overLoad = res.data.data.overloadCount.indexOf('%') > -1 ? res.data.data.overloadCount.split('%')[0] : ""
                        this.speedOver = res.data.data.speedOverCount.indexOf('%') > -1 ? res.data.data.speedOverCount.split('%')[0] : ''
                        this.collision = res.data.data.collisionCount.indexOf('%') > -1 ? res.data.data.collisionCount.split('%')[0] : ''
                        this.leaveFence = res.data.data.leaveFenceCount.indexOf('%') > -1 ? res.data.data.leaveFenceCount.split('%')[0] : ''
                        this.outPosition = res.data.data.outPositionCount.indexOf('%') > -1 ? res.data.data.outPositionCount.split('%')[0] : ''
                        this.FaultPie(this.overLoad,this.speedOver,this.collision,this.leaveFence,this.outPosition)
                    }
                }
                this.pieLoading = false
            }).catch(err => {
                this.pieLoading = false
            })
        },
        
        FaultPie(overLoad,speedOver,collision,leaveFence,outPosition) {
            let option = {
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                legend: {
                    orient: 'vertical',
                    left: '5%',
                    top: 'center',
                    itemWidth: 10,   
                    itemHeight: 10,  
                    itemGap: 20,
                    textStyle: {
                        color: '#fff'
                    },
                    data: [this.$t('GovernmentRegulation.overloadCount'), this.$t('GovernmentRegulation.speedOverCount'), this.$t('GovernmentRegulation.outPositionCount'), this.$t('GovernmentRegulation.collisionCount'), this.$t('GovernmentRegulation.leaveFenceCount')]
                },
                series: [
                    {
                        name: this.$t('common.number'),
                        type: 'pie',
                        radius: ['45%', '65%'],
                        center: ['60%', '50%'],
                        data: [
                            {value:overLoad, name:this.$t('GovernmentRegulation.overloadCount')},
                            {value:speedOver, name:this.$t('GovernmentRegulation.speedOverCount')},
                            {value:outPosition, name:this.$t('GovernmentRegulation.outPositionCount')},
                            {value:collision, name:this.$t('GovernmentRegulation.collisionCount')},
                            {value:leaveFence, name:this.$t('GovernmentRegulation.leaveFenceCount')},
                        ],
                        label: {
                            color: '#fff'
                        },
                        color: ['#48e1f9','#409eff','#8f70f7','#d860a1','#fc5b62','#f69c70'],
                    }
                ]
            }
            this.optionPie = option
        },

        getMonthOrderList() {
            let param = {
                orgId: this.orgId,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                selectType: 1,
                startTime: this.changeValue[0],
                endTime: this.changeValue[1],
            };
            this.$store.dispatch('DriverAnalysis/GET_QUERYMISTAKEPAGEBYDRIVER', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        getOneMonthOrderList() {
            let param = {
                orgId: this.orgId,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                selectType: 1,
                driverNum: this.driverNum,
                startTime: this.changeValue[0],
                endTime: this.changeValue[1],
            };
            this.$store.dispatch('DriverAnalysis/GET_QUERYMISTAKEPAGEBYDRIVER', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        downCar() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/mistake/uploadMistakePageByDriver?orgId=${this.orgId}&selectType=${1}&startTime=${this.changeValue[0]}&endTime=${this.changeValue[1]}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/mistake/uploadMistakePageByDriver?orgId=${this.orgId}&selectType=${1}&startTime=${this.changeValue[0]}&endTime=${this.changeValue[1]}`
                    location.href = url
                }
            }
        },
        down() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/mistake/uploadMistakePageByDriver?orgId=${this.orgId}&selectType=${1}&driverNum=${this.bindDriver}&startTime=${this.changeValue[0]}&endTime=${this.changeValue[1]}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/mistake/uploadMistakePageByDriver?orgId=${this.orgId}&selectType=${1}&driverNum=${this.bindDriver}&startTime=${this.changeValue[0]}&endTime=${this.changeValue[1]}`
                    location.href = url
                }
            }
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            if (this.type == 'one') {
                this.columns = this.columnsOne
                this.getOneMonthOrderList()
            } else {
                this.columns = this.columnsAll
                this.getMonthOrderList()
            }
        },
    }
}
